import type { ReactNode } from 'react';
import isFunction from 'lodash/isFunction';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (loadingComponent?: ReactNode | null) => {
	const renderer = isFunction(loadingComponent) ? loadingComponent : () => loadingComponent || null;

	return renderer();
};
